<script lang="ts" setup>
// #引言文字
import { type Text } from '@/utils/types/TextEditor'
const props = defineProps({
  data: {
    type: Object as any
  },
  color: {
    type: String,
    default: 'black'
  }
})

const textData = ref()

if (props.data && props.data.text) {
  const text: Ref<Text> = ref(props.data.text)
  textData.value = text.value
}
</script>

<template>
  <div class="area">
    <div :class="`area__text__${color}`" v-html="textData"></div>
  </div>
</template>

<style lang="scss" scoped>
.area {
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  &__text__black {
    position: relative;
    padding-left: toRem(60);
    padding-right: toRem(60);
    max-width: toRem(690);
    font-size: toRem(22);
    font-weight: 500;
    line-height: 1.3;

    @include max-media(480) {
      font-size: toRem(16);
      padding-left: toRem(40);
      padding-right: toRem(40);
    }

    &::before,
    &::after {
      position: absolute;
      top: toRem(7);
      font-family: $font-TextaAlt;
      font-size: toRem(50);
      font-weight: 500;
      color: $color-gray-3;

      @include max-media(480) {
        font-size: toRem(36);
      }
    }

    &::before {
      content: '“';
      left: 0;
    }

    &::after {
      content: '”';
      right: 0;
    }
  }

  &__text__yellow {
    position: relative;
    padding-left: toRem(60);
    padding-right: toRem(60);
    max-width: toRem(690);
    font-size: toRem(22);
    font-weight: 500;
    line-height: 1.3;

    @include max-media(480) {
      font-size: toRem(16);
      padding-left: toRem(40);
      padding-right: toRem(40);
    }

    &::before,
    &::after {
      position: absolute;
      top: toRem(7);
      font-family: $font-TextaAlt;
      font-size: toRem(50);
      font-weight: 500;
      color: $color-brand-4_1;

      @include max-media(480) {
        font-size: toRem(36);
      }
    }

    &::before {
      content: '“';
      left: 0;
    }

    &::after {
      content: '”';
      right: 0;
    }
  }
}
</style>
